<script setup lang="ts">
import { COLLAGE_LAYOUTS } from '@pfe/design-renderer'
import { useDesignStore } from '../../../store/useDesignStore'

const store = useDesignStore()
</script>

<template>
  <div class="lo">
    <p class="lo__hint">Ein Layout ordnet deine Fotos in Slots an. Vorhandene Bilder werden übernommen.</p>
    <div class="lo__grid">
      <button v-for="l in COLLAGE_LAYOUTS" :key="l.id" type="button" class="lo__item" :title="l.name" @click="store.applyLayout(l.id)">
        <svg viewBox="0 0 100 70" aria-hidden="true">
          <rect v-for="(s, i) in l.slots" :key="i" :x="s.x * 100 + 1.5" :y="s.y * 70 + 1.5" :width="s.w * 100 - 3" :height="s.h * 70 - 3" rx="2" fill="rgba(15,23,42,0.18)" />
        </svg>
        <span>{{ l.name }}</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.lo { display: grid; gap: 10px; padding: 12px; }
.lo__hint { font-size: 12px; color: var(--pfe-color-muted, rgba(15, 23, 42, 0.62)); }
.lo__grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(96px, 1fr)); gap: 8px; }
.lo__item { display: grid; gap: 4px; padding: 6px; border: 1px solid var(--pfe-color-border, rgba(15, 23, 42, 0.14)); border-radius: 8px; background: #fff; font: inherit; font-size: 11px; cursor: pointer; }
.lo__item svg { width: 100%; height: auto; }
.lo__item:hover { border-color: var(--pfe-color-accent, #e30b17); }
</style>
